/* js helpers */
const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

window.KEYCODES = {
  TAB: 9,
  ESC: 27,
  DOWN: 40,
  RIGHT: 39,
  UP: 38,
  LEFT: 37,
  RETURN: 13
};

/* resize handler for background images registered in window.rbi (defined inline) */
window.addEventListener('resize', debounce(() => {
  for (let img of window.rbi) {
    window.rbiSetSize(img);
  }
}, 250));
